import { Box } from '@mui/material';

import { HotelAvailabilitySearchLayout } from '@frontend/features/hotel/components/Availability';
import { HotelSearchContextProvider } from '@frontend/features/hotel/components/Availability/Search/HotelSearchContext';

// import { FeaturedSection } from '../../features/offers/components/FeaturedSection';
// import { OfferSection } from '../../features/offers/components/OfferSection';
import { useBreakpoints } from '../../features/common/hooks/useBreakpoints';

export const Hotels = () => {
  const { gap } = useBreakpoints();

  return (
    <Box display="flex" flexDirection="column" gap={gap} paddingBottom={gap}>
      <HotelSearchContextProvider>
        <HotelAvailabilitySearchLayout />
        {/* 
          <OfferSection />
          <FeaturedSection />
        */}
      </HotelSearchContextProvider>
    </Box>
  );
};
